import { Layout } from "antd";
import React, { ReactElement } from "react";
const { Footer } = Layout;

const HomeFooter = (): ReactElement => {
  return <Footer className="text-center">Powered by Zachai.com Ltd.</Footer>;
};

export default HomeFooter;
